/*global RdcTracking */
import { getPageName, getSiteSection } from './srp_tracking_helper';
import { setupSrpClickTracking } from './srp_clicks';

const DEFAULT_VALUE = 'unknown';

let searchFacetDidFire = false;

// source is optional and only needed to keep pagination and search facet from double firing in some instances.
export const setupSrpPageTracking = function(source) {
  if (MOVE_DATA && MOVE_DATA.adobeDTM) {
    const pageName = getPageName();
    trackSrpPageLoad(pageName, source);
    setupSrpClickTracking(pageName);

    // To track control for recommended search/smart notification
    if (!MOVE_DATA.srpNotificationFooter && RdcTracking) {
      RdcTracking.trackEvent('srpUpdateFeedImpression', { linkName: 'RECOMMENDED_SEARCH:control:no_update' });
    }
  }
};

export const trackSrpPageLoad = (pageName, source='unspecified') => {
  const fireTracking = () => RdcTracking.trackPage(pageName, prepareLoadEventData(MOVE_DATA.adobeDTM));
  if (source === 'searchFacet') {
    searchFacetDidFire = true;
    fireTracking();
  } else if (source === 'pagination' && searchFacetDidFire ) {
    searchFacetDidFire = false
  } else if (MOVE.DataStore.getData('NotifyTab') === 'notification-tab') {
    searchFacetDidFire = false
  } else {
    fireTracking();
  }
};

const prepareLoadEventData = () => {
  var adobeDTM = MOVE_DATA.adobeDTM;
  return (
    {
      appVersion: `rdc-next-basecamp-${process.env.GIT_BRANCH}`,
      abTestSrp: getAbTestVariables(),
      city: adobeDTM['searchCity'] || DEFAULT_VALUE,
      communityIdShowcase: adobeDTM['communityID-showcase'],
      communityIdBasic: adobeDTM['communityID-basic'],
      communityIdFeatured: adobeDTM['communityID-featured'],
      county: adobeDTM['searchCounty'] || DEFAULT_VALUE,
      listingActivity: adobeDTM['searchListingActivity'] ? adobeDTM['searchListingActivity'].toString() : DEFAULT_VALUE,
      listingIdAdvantage: getListingIdAdvantage(adobeDTM['listingID-advantage']),
      listingIdBasicoo: getListingIdBasicoo(adobeDTM['listingID-basicoo']),
      listingIdBasic: adobeDTM['listingID-basic'],
      listingIdShowcase: adobeDTM['listingID-showcase'],
      listingIdCobroke: adobeDTM['listingID-cobroke'],
      neighborhood: adobeDTM['searchNeighborhood'],
      neighborhoodCount: adobeDTM['neighborhoodCount'],
      pageId: adobeDTM['pageId'] || DEFAULT_VALUE,
      pageSize: "srp:" + adobeDTM['searchPageSize'],
      pageType: adobeDTM['pageType'],
      pagination: "srp:" + 	adobeDTM['searchPage'],
      planIdShowcase: adobeDTM['planID-showcase'],
      propertyStatus: adobeDTM['propertyStatus'] || DEFAULT_VALUE,
      propertyStatusSub: adobeDTM['propertyStatusSub'] || DEFAULT_VALUE,
      propertyType: "srp:" + adobeDTM['searchPropertyType'] || DEFAULT_VALUE,
      searchBedrooms: adobeDTM['searchBedrooms'],
      searchBathrooms: adobeDTM['searchBathrooms'],
      searchCityState: adobeDTM['searchCity']+", "+adobeDTM['searchState'],
      searchFacets: "web:facets:" + adobeDTM['searchFacets'],
      searchFeatures: "web:features:"+ adobeDTM['searchFeatures'],
      searchId: adobeDTM['searchID'],
      searchMinPrice: adobeDTM['searchMinPrice'],
      searchMaxPrice: adobeDTM['searchMaxPrice'],
      searchMod: adobeDTM['searchMod'],
      searchProductType: adobeDTM['productType'],
      searchRadius: "srp:" + adobeDTM['searchRadius'],
      searchResults: adobeDTM['searchResultCount'],
      searchSqFt: adobeDTM['searchSqFt'],
      searchType: MOVE_DATA.customSearchType || adobeDTM['searchType'],
      siteSection: getSiteSection(adobeDTM['propertyStatus']),
      sortResults: adobeDTM['searchSortResults'],
      srpColumns: adobeDTM['srpColumns'],
      srpHotBuyCount: adobeDTM['srpHotBuyCount'],
      srpPropertyStatus: "srp:" + getSrpPropertyStatus(adobeDTM['propertyStatus'], adobeDTM['propertyStatusSub']),
      srpResultType: getSrpResultType(),
      state: adobeDTM['searchState'] || DEFAULT_VALUE,
      subIdShowcase: adobeDTM['subID-showcase'],
      userStatus: "web:" + $.cookie('userStatus'),
      zip: adobeDTM['searchZip'] || DEFAULT_VALUE,
      imageSwappedCount: MOVE.DataStore && MOVE.DataStore.getData('abImgCtrSwapCount'),
    }
  );
};

const getAbTestVariables = () => {
  var elems = document.querySelectorAll("input[data-optimizely]"),
      retValue = '';
  for (var j = 0; j < elems.length; j++) {
    if ( j > 0 ) { retValue += ',' }
    retValue += elems[j].getAttribute("data-optimizely");
  }
  return retValue;
};

const getListingIdAdvantage = (val) => {
  var lid = decodeURIComponent(val),
      ary1 = lid.split(','),
      retAry = '';
  ary1.forEach((id) => {
    const ary2 = id.split(':');
    if (ary2.length > 1){
       retAry += `${ary2[0]}:${ary2[1]},`;
    }
  })
  return retAry.slice(0, retAry.length-1);
};

const getListingIdBasicoo = (val) => {
  var lid = decodeURIComponent(val),
      ary1 = lid.split(','),
      retAry = [];
  for (var i=0;i<ary1.length;i++){
      var ary2 = ary1[i].split(':');
      if (ary2.length > 1){
          retAry.push(ary2[0]+':'+ary2[1]);
      }
  }
  return retAry.toString();
};

const getSrpPropertyStatus = (propertyStatus, propertyStatusSub) => {
  return propertyStatusSub ? `${propertyStatus}:${propertyStatusSub}` : propertyStatus;
}

const getSrpResultType = () => {
  var resultCnt = MOVE_DATA.adobeDTM.searchResultCount,
      resultNearByCnt = MOVE_DATA.adobeDTM.searchNearByResultCount, //not exist
      resultType = MOVE_DATA.adobeDTM.resultType,
      searchType = MOVE_DATA.adobeDTM.searchType; // Remove search Type condition oncce NearBy issue is fixed

    if (searchType == "school" && resultType) return resultType;
    if (resultCnt > 0) return "normal";
    if (resultNearByCnt > 0) return "nearby";

    return "no result";
};


// WEBPACK FOOTER //
// ./shared_critical/tracking/pages/srp/srp_page_load.js